import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmApiAccountPhoneAlreadyVerifiedError extends TmApiValidationError {
  public name = 'TmApiAccountPhoneAlreadyVerifiedError'
}
